import * as React from "react";
import "./mainHeader.css";
import {connect} from "react-redux";

const MainHeader = (props) => {
    return (
        <div className="main-header-wrapper">
            <div className={"flex-items"}>
            <span className={"dls-gray-06 store-header"}
                  onClick={() => props.history.push("/")}>
                SHOP'n PAY
            </span>
                <div className={"flex"}>
                    <span className="icon icon-lg icon-hover dls-icon-account dls-gray-05"/>
                    <span className={"divider"}/>
                    <span className="icon icon-lg icon-hover dls-icon-cart dls-gray-05"
                          onClick={() => window.location.href = "/checkout"}/>
                </div>
            </div>
        </div>
    );

};


export default connect((src) => (src))(MainHeader);
